// extracted by mini-css-extract-plugin
export default {"modal":"HardwareFirstSizingModal_modal__vGMdQ","closeIcon":"HardwareFirstSizingModal_closeIcon__Svppt"};